import { CircularProgress, Stack, Typography } from '@mui/material';
import { IconChip, IconLibrary } from '@product-framework/index';
import { useDataProvider } from '@ui-framework/index';
import { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';

function DistanceFromCustomer({
  jobLocation,
  serviceProviderAddressLocation,
  locationId,
}) {
  const { get, getApiUrl } = useDataProvider();
  const [distance, setDistance] = useState(0);
  const [loading, isLoading] = useState(true);

  const query = `destinationLat=${serviceProviderAddressLocation.lat}&destinationLng=${serviceProviderAddressLocation.lng}&originLat=${jobLocation.lat}&originLng=${jobLocation.lng}`;

  const apiUrl = `${getApiUrl()}/sxcl/v1/geocoding/routing-distance?${query}`;

  const getDistance = async () => {
    isLoading(true);
    const response = await get(apiUrl);
    if (response?.ok) {
      setDistance(response?.data?.distance || '');
    }
    isLoading(false);
  };

  useEffect(() => {
    getDistance();
  }, [locationId]);

  if (loading) {
    return <CircularProgress sx={{ ml: 1 }} size={15} />;
  }

  return (
    <Stack
      direction="row"
      sx={{ justifyContent: 'space-between', alignItems: 'center' }}>
      <Stack
        direction="row"
        spacing={0.5}
        sx={{ alignItems: 'center', justifyContent: 'left' }}>
        <IconChip
          bgColor="primary.light"
          iconColor="primary.main"
          Icon={IconLibrary.DrivingDistance}
          size={30}
          iconFontSize="18px"
        />
        <Typography variant="subtitle2" color="text.secondary">
          <FormattedMessage
            id="DRIVING_DISTANCE_FROM_CUSTOMER"
            defaultMessage="Driving Distance From Customer: "
          />
        </Typography>
      </Stack>
      <Typography variant="body2" sx={{ fontWeight: 500, textAlign: 'right' }}>
        {distance}
      </Typography>
    </Stack>
  );
}

export default DistanceFromCustomer;
